import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { HeadsetActivationCode, ProblemHeadset } from 'src/models';
import { fetchProblemHeadsetsAction } from 'src/services/problemHeadsets';

const problemHeadsetsEntityAdapter = createEntityAdapter({
  selectId: (headset: ProblemHeadset) => headset.id,
});

export const problemHeadsetsSelectors =
  problemHeadsetsEntityAdapter.getSelectors();

const initialState: {
  activationCode: HeadsetActivationCode | null;
  isPending: boolean | null;
  hasError: boolean;
} = {
  activationCode: null,
  isPending: null,
  hasError: false,
};

const problemHeadsetsSlice = createSlice({
  name: 'problem_headsets',
  initialState: problemHeadsetsEntityAdapter.getInitialState(initialState),
  reducers: {
    resetProblemHeadsetsState: (state) => {
      state.isPending = null;
      state.hasError = false;
      problemHeadsetsEntityAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProblemHeadsetsAction.pending, (state) => {
      state.activationCode = null;
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(
      fetchProblemHeadsetsAction.fulfilled,
      (state, { payload }) => {
        state.isPending = false;
        problemHeadsetsEntityAdapter.setAll(state, payload);
      },
    );
    builder.addCase(fetchProblemHeadsetsAction.rejected, (state) => {
      state.isPending = false;
      state.hasError = true;
    });
  },
});

const { reducer, actions } = problemHeadsetsSlice;

export const { resetProblemHeadsetsState } = actions;

export default reducer;
